import { useSelector } from 'react-redux';
import { getCurrentLanguageSelector } from '@app/reducers/i18n';

import { T } from '@app/components/translation';

import type { PlaybookValues } from '../../../types';
import { getInsightTexts } from '../../../texts';

type Props = {
  values: PlaybookValues;
  insightType: string;
};

export const Playbook: React.FC<Props> = ({ values, insightType }: Props): React.ReactElement => {
  const currentLanguage = useSelector(getCurrentLanguageSelector) || 'en';
  const insightsTexts = getInsightTexts(currentLanguage);

  if (insightsTexts[insightType]?.getPlaybookText) {
    return insightsTexts[insightType].getPlaybookText(values);
  }

  return (
    <T
      _str="Missing"
      _comment="Fallback text"
    />
  );
};
